export const EnumGender = {
  MALE: 1,
  FEMALE: 2
}

export const EnumStatus = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2
}